import { semesterForDate } from '../utils/semester';
// src/pages/DashboardPage.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import { getSubjects, getClassrooms, getCurrentYear, getLevels, getClassroomSettings, getSchoolSettings, getQualityTypes, getQualityProgress, getSchedules, getHolidays, getPeriods, getDashboardStats, getRemedialActivities, getSubstitutes, getClubs, checkMyFeaturePermission } from '../services/api';
import { classroomLabel, levelCodePrefix } from '../utils/classroom';
import './DashboardPage.css';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const ACADEMIC_ROLES = ['admin', 'director', 'academic', 'assessment'];

const ROLE_LABELS = {
  admin: 'ผู้ดูแลระบบ',
  academic: 'ครูวิชาการ',
  assessment: 'ครูวัดผล',
  teacher: 'ครูผู้สอน',
  homeroom: 'ครูประจำชั้น',
};

// ---- helpers เหมือน ClassroomsPage ----
const _GRADE_KEY_DISPLAY = {
  k1:1,k2:2,k3:3,p1:1,p2:2,p3:3,p4:4,p5:5,p6:6,m1:1,m2:2,m3:3,h1:4,h2:5,h3:6,
};
const _ACTIVE_KEYS_MAP = {
  'k1-p6':['k1','k2','k3','p1','p2','p3','p4','p5','p6'],
  'k2-p6':['k2','k3','p1','p2','p3','p4','p5','p6'],
  'k1-m3':['k1','k2','k3','p1','p2','p3','p4','p5','p6','m1','m2','m3'],
  'k2-m3':['k2','k3','p1','p2','p3','p4','p5','p6','m1','m2','m3'],
  'p1-p6':['p1','p2','p3','p4','p5','p6'],
  'p1-m3':['p1','p2','p3','p4','p5','p6','m1','m2','m3'],
  'm1-m3':['m1','m2','m3'],
  'm1-h3':['m1','m2','m3','h1','h2','h3'],
  'h1-h3':['h1','h2','h3'],
  'p1-h3':['p1','p2','p3','p4','p5','p6','m1','m2','m3','h1','h2','h3'],
  'all':['k1','k2','k3','p1','p2','p3','p4','p5','p6','m1','m2','m3','h1','h2','h3'],
};
function _buildKeyMap(levelList) {
  const kL = levelList.find(l => /อนุบาล|kindergarten/i.test(l.level_name) || /^อ$/i.test(l.level_code));
  const pL = levelList.find(l => /ประถม|primary/i.test(l.level_name) || /^ป$/i.test(l.level_code));
  const mL = levelList.find(l => /ต้น|junior|middle/i.test(l.level_name) || /ม\.ต้น/i.test(l.level_code));
  const hL = levelList.find(l => /ปลาย|senior|high/i.test(l.level_name) || /ม\.ปลาย/i.test(l.level_code));
  const mk = (lvl, g, dg) => lvl ? { level_id: lvl.id, level_code: lvl.level_code, grade: g, displayGrade: dg } : null;
  return {
    k1:mk(kL,1,1),k2:mk(kL,2,2),k3:mk(kL,3,3),
    p1:mk(pL,1,1),p2:mk(pL,2,2),p3:mk(pL,3,3),p4:mk(pL,4,4),p5:mk(pL,5,5),p6:mk(pL,6,6),
    m1:mk(mL,1,1),m2:mk(mL,2,2),m3:mk(mL,3,3),
    h1:mk(hL,4,4),h2:mk(hL,5,5),h3:mk(hL,6,6),
  };
}
function generateDisplayRooms(gradeRange, activeSettings, levelList, dbClassrooms) {
  const gradeKeys = _ACTIVE_KEYS_MAP[gradeRange];
  if (!gradeKeys || activeSettings.length === 0) return [];
  const keyMap = _buildKeyMap(levelList);
  const setting = activeSettings[0];
  const rows = [];
  for (const gk of gradeKeys) {
    const info = keyMap[gk];
    if (!info) continue;
    const roomCount = Number(setting[`rooms_${gk}`] || 0);
    if (roomCount === 0) continue;
    const dg = _GRADE_KEY_DISPLAY[gk];
    for (let room = 1; room <= roomCount; room++) {
      const dbRoom = dbClassrooms.find(
        c => Number(c.level_id) === Number(info.level_id)
          && Number(c.grade) === Number(info.grade)
          && Number(c.room) === room
      );
      rows.push({
        key: `${gk}_${room}`,
        label: `${levelCodePrefix(info.level_code)}${dg}/${room}`,
        level_id: info.level_id, level_code: info.level_code,
        grade: info.grade, displayGrade: dg, room,
        id: dbRoom?.id,
        homeroom1_name: dbRoom?.homeroom1_name,
        homeroom2_name: dbRoom?.homeroom2_name,
        student_count: dbRoom?.student_count || 0,
        homeroom_teacher_id: dbRoom?.homeroom_teacher_id,
        homeroom_teacher2_id: dbRoom?.homeroom_teacher2_id,
        level_name: dbRoom?.level_name || '',
      });
    }
  }
  return rows;
}
// ----------------------------------------

export default function DashboardPage() {
  const { user, isAcademic } = useAuth();
  const navigate = useNavigate();
  const [subjects, setSubjects] = useState([]);
  const [displayRooms, setDisplayRooms] = useState([]);
  const [currentYear, setCurrentYear] = useState(null);
  const [qTypes, setQTypes] = useState([]);
  const [qualProgress, setQualProgress] = useState({});
  const [filterGrade, setFilterGrade] = useState('');
  const [filterRoom, setFilterRoom] = useState('');
  const [isSem2, setIsSem2] = useState(false);
  const [loading, setLoading] = useState(true);
  const [todayLessons, setTodayLessons] = useState([]);
  const [allClubs, setAllClubs] = useState([]);
  const [allSchedules, setAllSchedules] = useState([]);
  const [remedialActivitiesAll, setRemedialActivitiesAll] = useState([]);
  const [adminStats, setAdminStats] = useState(null);
  const [adminStatsLoading, setAdminStatsLoading] = useState(false);
  // ── ตารางสอนทั้งโรงเรียนวันนี้ (สำหรับ admin/academic) ──
  const [schoolDaySchedules, setSchoolDaySchedules] = useState([]);
  const [schoolDaySubstitutes, setSchoolDaySubstitutes] = useState([]);
  const [schoolDayPeriods, setSchoolDayPeriods] = useState([]);
  const [schoolDayInfo, setSchoolDayInfo] = useState({ date: '', dow: 0, isHoliday: false, holidayName: '' });
  const [schoolDayFilterTeacher, setSchoolDayFilterTeacher] = useState('');

  // Helper: determine semester from date + classroom_settings
  const detectSemester = semesterForDate;

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    const academicUser = ACADEMIC_ROLES.includes(user.role);

    const loadAdminStats = async () => {
      if (!academicUser) return;
      setAdminStatsLoading(true);
      for (let attempt = 0; attempt < 2; attempt++) {
        try {
          const r = await getDashboardStats();
          if (cancelled) return;
          if (r.data?.success) {
            setAdminStats(r.data.data);
            break;
          }
        } catch (e) {
          if (attempt === 1) {
            console.error('[Dashboard] getDashboardStats error:', e?.response?.status, e?.response?.data || e?.message);
          }
        }
        if (attempt === 0) await new Promise(res => setTimeout(res, 800));
      }
      if (!cancelled) setAdminStatsLoading(false);
    };

    const fetch = async () => {
      setLoading(true);
      loadAdminStats();

      try {
        // ── Batch 1: โหลดข้อมูลพื้นฐานทั้งหมดพร้อมกัน (ลด waterfall) ──
        const [yearRes, subRes, lvlRes, sSettings, clsRes, stRes] = await Promise.all([
          getCurrentYear(),
          getSubjects({ teacher_id: academicUser ? undefined : user?.id }),
          getLevels(),
          getSchoolSettings().catch(() => ({ data: { data: null } })),
          getClassrooms({ academic_year_id: '__current__' }).catch(() => ({ data: { data: [] } })),
          getClassroomSettings({ academic_year_id: '__current__' }).catch(() => ({ data: { data: [] } })),
        ]);
        if (cancelled) return;
        const year = yearRes.data.success ? yearRes.data.data : null;
        if (year) setCurrentYear(year);
        const subList = subRes.data.success ? subRes.data.data : [];
        setSubjects(subList);

        const ss = sSettings.data.data || {};
        const isLockedFn = (v, dt) => (v === 1 || v === '1' || v === true) || (dt && new Date() >= new Date(dt));
        setIsSem2(isLockedFn(ss.lock_sem1, ss.lock_date_sem1));

        const levelList = lvlRes.data.data || [];
        const gradeRange = ss.grade_range || '';

        // ── สร้าง displayRooms จากข้อมูลที่โหลดมาแล้ว (ไม่ต้อง await อีก) ──
        const dbClassrooms = clsRes.data.data || [];
        const activeSettings = (stRes.data.data || []).filter(s => Number(s.is_active) === 1);
        const rooms = generateDisplayRooms(gradeRange, activeSettings, levelList, dbClassrooms);
        setDisplayRooms(rooms.length > 0 ? rooms : dbClassrooms.map(c => ({
          key: `db_${c.id}`, label: classroomLabel(c),
          id: c.id, level_id: c.level_id, level_code: c.level_code,
          grade: c.grade, displayGrade: c.grade, room: c.room,
          homeroom1_name: c.homeroom1_name, homeroom2_name: c.homeroom2_name,
          student_count: c.student_count || 0,
          homeroom_teacher_id: c.homeroom_teacher_id,
          homeroom_teacher2_id: c.homeroom_teacher2_id,
          level_name: c.level_name || '',
        })));

        // ── Batch 2: โหลดข้อมูลเสริมพื้นหลัง (ไม่ block หน้าหลัก) ──
        if (!cancelled) setLoading(false);

        const batch2 = [];

        // Quality types
        if (year) {
          batch2.push(
            getQualityTypes({ academic_year_id: year.id })
              .then(qtRes => {
                const qt = (qtRes.data.data || []).filter(t => Number(t.is_enabled) === 1);
                setQTypes(qt);
              })
              .catch(() => {})
          );
        }

        // Quality progress — 1 request แทนวน loop ทีละห้อง
        if (year && subList.length > 0) {
          const cids = [...new Set(subList.map(s => s.classroom_id).filter(Boolean))];
          if (cids.length > 0) {
            batch2.push((async () => {
              try {
                const r = await getQualityProgress({ classroom_ids: cids.join(','), academic_year_id: year.id });
                if (r.data.success) {
                  const qpMap = {};
                  (r.data.data || []).forEach(d => {
                    if (!qpMap[d.subject_id]) qpMap[d.subject_id] = {};
                    if (!qpMap[d.subject_id][d.type_key]) qpMap[d.subject_id][d.type_key] = {};
                    qpMap[d.subject_id][d.type_key][d.semester] = Number(d.scored_count) || 0;
                  });
                  setQualProgress(qpMap);
                }
              } catch {}
            })());
          }
        }

        // ตารางสอนวันนี้ (สำหรับครู)
        if (year && (user?.role === 'teacher' || user?.role === 'academic')) {
          batch2.push((async () => {
            try {
              const allSemSettings = stRes.data.data || [];
              const today = new Date().toISOString().slice(0, 10);
              const sem = detectSemester(allSemSettings, today);

              const [schRes, holRes, perRes, subAsSubRes, subAsOrigRes, clubsRes] = await Promise.all([
                getSchedules({ academic_year_id: year.id, user_id: user.id, both_semesters: 1 }),
                getHolidays({ academic_year_id: year.id }),
                getPeriods({ academic_year_id: year.id }),
                getSubstitutes({ academic_year_id: year.id, date: today }).catch(() => ({ data: { data: [] } })),
                getSubstitutes({ academic_year_id: year.id, date: today, mode: 'as_original' }).catch(() => ({ data: { data: [] } })),
                getClubs({ academic_year_id: year.id }).catch(() => ({ data: { data: [] } })),
              ]);
              setAllClubs(clubsRes.data?.data || []);
              const schedules = schRes.data.data || [];
              setAllSchedules(schedules);
              // filter: เฉพาะรายการสอนแทนของตัวเอง (backend return ทุกครู)
              const coveredList = (subAsOrigRes.data?.data || []).filter(s =>
                String(s.original_user_id || '') === String(user.id)
              );

              const holidays = holRes.data.data || [];
              const periodsList = perRes.data.data || [];
              const dateObj = new Date(today + 'T00:00:00');
              const rawDow = dateObj.getDay();
              const holidayInfo = holidays.find(h => h.holiday_date === today);
              const isHoliday = holidayInfo?.holiday_type === 'holiday';
              const isCompensation = holidayInfo?.holiday_type === 'compensation';
              const effectiveDow = isCompensation && holidayInfo.compensation_day_of_week
                ? Number(holidayInfo.compensation_day_of_week) : rawDow;
              const isWeekend = rawDow === 0 || rawDow === 6;
              const isSchoolDay = (!isWeekend && !isHoliday) || isCompensation;

              if (isSchoolDay) {
                const lessons = schedules
                  .filter(s => Number(s.day_of_week) === effectiveDow)
                  .map(s => {
                    const isRemNote = s.note?.startsWith('ซ่อมเสริม:');
                    const base = Number(s.is_co_teacher) === 1 ? { ...s, _isCoTeacher: true } : s;
                    const covered = coveredList.find(c =>
                      String(c.classroom_id) === String(s.classroom_id) && String(c.period_id) === String(s.period_id)
                    );
                    const withCover = covered ? { ...base, _coveredBy: covered.substitute_teacher_name, _coveredNote: covered.note } : base;
                    if (!isRemNote) return withCover;
                    const remName = s.note.replace('ซ่อมเสริม:', '').trim();
                    return { ...withCover, subject_name: remName, _isRemedial: true, _remedialColor: '#059669' };
                  })
                  .sort((a, b) => Number(a.period_number) - Number(b.period_number));

                // เพิ่มคาบโฮมรูมสำหรับห้องที่เป็นครูประจำชั้น (ถ้ายังไม่มีใน schedule)
                const myHomeroomCls = dbClassrooms.filter(c =>
                  String(c.homeroom_teacher_id) === String(user.id) || String(c.homeroom_teacher2_id) === String(user.id)
                );

                // ผู้มีสิทธิ์จัดการสอนแทน (หัวหน้าระดับชั้น): เพิ่มห้องของครูประจำชั้นที่ "ไม่อยู่" (มีรายการสอนแทนวันนี้)
                const absentHomeroom = new Map(); // classroom_id → [ชื่อครูที่ไม่อยู่...]
                try {
                  const canManage = !!(await checkMyFeaturePermission('substitute_manage')
                    .then(r => r.data?.allowed).catch(() => false));
                  const allDaySubs = subAsSubRes.data?.data || []; // รายการสอนแทนทั้งหมดของวันนี้ (ทุกครู)
                  if (canManage && allDaySubs.length > 0) {
                    const absentUserIds = new Set(
                      allDaySubs.map(s => String(s.original_user_id || '')).filter(Boolean)
                    );
                    dbClassrooms.forEach(c => {
                      const cid = String(c.id);
                      const hrIds = [String(c.homeroom_teacher_id || ''), String(c.homeroom_teacher2_id || '')].filter(Boolean);
                      hrIds.forEach(hrId => {
                        if (!absentUserIds.has(hrId)) return;
                        const sub = allDaySubs.find(s => String(s.original_user_id) === hrId);
                        const name = sub?.original_teacher_name || '';
                        const list = absentHomeroom.get(cid) || [];
                        if (name && !list.includes(name)) list.push(name);
                        absentHomeroom.set(cid, list);
                      });
                    });
                  }
                } catch { /* ignore */ }

                // รวมห้องที่ต้องแสดงคาบโฮมรูม (ของตัวเอง + ห้องครูที่ไม่อยู่)
                const clsToShow = [...myHomeroomCls];
                absentHomeroom.forEach((_names, cid) => {
                  if (!clsToShow.some(c => String(c.id) === cid)) {
                    const cls = dbClassrooms.find(c => String(c.id) === cid);
                    if (cls) clsToShow.push(cls);
                  }
                });

                clsToShow.forEach(cls => {
                  const hrPeriod = periodsList.find(p =>
                    Number(p.is_homeroom) && (!p.level_id || String(p.level_id) === String(cls.level_id))
                  );
                  if (!hrPeriod) return;
                  const exists = lessons.some(l =>
                    String(l.classroom_id) === String(cls.id) && String(l.period_id) === String(hrPeriod.id)
                  );
                  if (!exists) {
                    lessons.push({
                      classroom_id: cls.id,
                      period_id: hrPeriod.id,
                      period_number: hrPeriod.period_number,
                      period_name: hrPeriod.period_name,
                      start_time: hrPeriod.start_time,
                      end_time: hrPeriod.end_time,
                      is_homeroom: 1,
                      subject_name: 'โฮมรูม',
                      subject_code: null,
                      level_code: cls.level_code,
                      grade: cls.grade,
                      room: cls.room,
                      day_of_week: effectiveDow,
                      // ครูประจำชั้นไม่อยู่ (เราเป็นหัวหน้าระดับมาเช็คแทน)
                      ...(absentHomeroom.has(String(cls.id))
                        ? { _teacherAway: true, _awayTeacherName: (absentHomeroom.get(String(cls.id)) || []).join(', ') }
                        : {}),
                    });
                  }
                });

                // เพิ่มกิจกรรมซ่อมเสริมที่ตรงกับวันนี้ (จาก schedules_raw ที่ยังไม่ได้บันทึกในตารางสอน)
                try {
                  const remRes = await getRemedialActivities({ academic_year_id: year.id });
                  const remActs = remRes.data?.data || [];
                  setRemedialActivitiesAll(remActs);
                  for (const act of remActs) {
                    if (!act.schedules_raw) continue;
                    act.schedules_raw.split(',').forEach(slot => {
                      const [sDow, sPid] = slot.split(':');
                      if (Number(sDow) !== effectiveDow) return;
                      // ไม่เพิ่มซ้ำถ้ามีอยู่ใน lessons แล้ว (note-based)
                      const alreadyIn = lessons.some(l =>
                        l._isRemedial && String(l.classroom_id) === String(act.classroom_id) &&
                        String(l.period_id) === String(sPid)
                      );
                      if (alreadyIn) return;
                      const period = sPid ? periodsList.find(p => String(p.id) === String(sPid)) : null;
                      const key = `remedial_${act.id}_${sPid || '0'}`;
                      if (lessons.some(l => l._key === key)) return;
                      lessons.push({
                        _key: key,
                        classroom_id: act.classroom_id,
                        period_id: period?.id || null,
                        period_number: period?.period_number ?? 99,
                        period_name: period?.period_name ?? 'ซ่อมเสริม',
                        start_time: period?.start_time ?? '',
                        end_time: period?.end_time ?? '',
                        is_homeroom: 0,
                        subject_name: act.name,
                        subject_code: null,
                        level_code: act.level_code || '',
                        grade: act.grade || '',
                        room: act.room || '',
                        day_of_week: effectiveDow,
                        _isRemedial: true,
                        _remedialActivityId: act.id,
                        _remedialColor: act.color || '#059669',
                      });
                    });
                  }
                } catch { /* ignore */ }

                // เพิ่มคาบที่ถูกมอบหมายให้สอนแทน (เฉพาะของตัวเอง)
                try {
                  const subList = (subAsSubRes.data?.data || []).filter(s =>
                    String(s.substitute_user_id || '') === String(user.id)
                  );
                  for (const sub of subList) {
                    const exists = lessons.some(l =>
                      String(l.classroom_id) === String(sub.classroom_id) &&
                      String(l.period_id) === String(sub.period_id)
                    );
                    if (!exists) {
                      const period = periodsList.find(p => String(p.id) === String(sub.period_id));
                      lessons.push({
                        classroom_id: sub.classroom_id,
                        period_id: sub.period_id,
                        period_number: period?.period_number ?? sub.period_number,
                        period_name: period?.period_name ?? sub.period_name,
                        start_time: period?.start_time ?? sub.start_time,
                        end_time: period?.end_time ?? sub.end_time,
                        is_homeroom: period?.is_homeroom ?? 0,
                        subject_name: sub.subject_name || 'สอนแทน',
                        subject_code: sub.subject_code || null,
                        subject_id: sub.effective_subject_id || sub.subject_id || null,
                        level_code: sub.level_name,
                        grade: sub.grade,
                        room: sub.room,
                        day_of_week: effectiveDow,
                        _isSubstitute: true,
                        _substituteFor: sub.original_teacher_name,
                        _substituteNote: sub.note,
                      });
                    }
                  }
                } catch { /* ignore */ }

                lessons.sort((a, b) => Number(a.period_number) - Number(b.period_number));

                // Deduplicate คาบชุมนุม (เพราะมีหลาย row จาก is_co_teacher) + annotate grade_filter
                // และ deduplicate วิชาที่มี co-teacher row (same classroom_id + period_id → เก็บ own row)
                const isClubCheck = (pn, sn) => /ชุมนุม|กิจกรรมชุมนุม|club/i.test(pn || '') || /ชุมนุม|กิจกรรมชุมนุม|club/i.test(sn || '');
                const clubsData = clubsRes.data?.data || [];
                const seenClubPid = new Set();
                // Dedup by classroom_id + period_id: own row (is_co_teacher=0) ชนะ
                const slotMap = new Map();
                for (const l of lessons) {
                  const k = `${l.classroom_id}|${l.period_id}`;
                  const existing2 = slotMap.get(k);
                  if (!existing2 || Number(l.is_co_teacher) === 0) {
                    slotMap.set(k, l);
                  }
                }
                const dedupLessons = [...slotMap.values()].sort((a, b) => Number(a.period_number) - Number(b.period_number));
                const finalLessons = [];
                for (const l of dedupLessons) {
                  if (isClubCheck(l.period_name, l.subject_name)) {
                    if (seenClubPid.has(String(l.period_id))) continue;
                    seenClubPid.add(String(l.period_id));
                    const myClub = clubsData.find(c => String(c.teacher_user_id) === String(user.id));
                    const gradeLabel = myClub?.grade_filter
                      ? myClub.grade_filter.split(',').filter(Boolean).map(gk => {
                          const [lid, grade] = gk.split(':');
                          const cls2 = dbClassrooms.find(c => String(c.level_id) === String(lid));
                          return `${levelCodePrefix(cls2?.level_code || '')}${grade}`;
                        }).join(', ')
                      : 'ทุกชั้น';
                    finalLessons.push({ ...l, _isClub: true, _clubId: myClub?.id, _clubName: myClub?.club_name || '', _clubGradeLabel: gradeLabel });
                  } else {
                    finalLessons.push(l);
                  }
                }
                finalLessons.sort((a, b) => Number(a.period_number) - Number(b.period_number));
                setTodayLessons(finalLessons);
              }
            } catch { /* ignore */ }
          })());
        }

        // ── ตารางสอนทั้งโรงเรียนวันนี้ (admin/academic) ──
        if (year && academicUser) {
          batch2.push((async () => {
            try {
              const today = new Date().toISOString().slice(0, 10);
              const allSemSettings = stRes.data.data || [];
              const sem = detectSemester(allSemSettings, today);
              const [holRes2, perRes2] = await Promise.all([
                getHolidays({ academic_year_id: year.id }).catch(() => ({ data: { data: [] } })),
                getPeriods({ academic_year_id: year.id }).catch(() => ({ data: { data: [] } })),
              ]);
              const holidays2 = holRes2.data.data || [];
              const periodsList2 = perRes2.data.data || [];
              const dateObj = new Date(today + 'T00:00:00');
              const rawDow = dateObj.getDay();
              const hInfo = holidays2.find(h => h.holiday_date === today);
              const isHoliday2 = hInfo?.holiday_type === 'holiday';
              const isComp = hInfo?.holiday_type === 'compensation';
              const effDow = isComp && hInfo.compensation_day_of_week
                ? Number(hInfo.compensation_day_of_week)
                : rawDow;
              setSchoolDayInfo({
                date: today, dow: effDow, isHoliday: isHoliday2,
                holidayName: hInfo?.holiday_name || '',
              });
              setSchoolDayPeriods(periodsList2);
              if (isHoliday2) { setSchoolDaySchedules([]); setSchoolDaySubstitutes([]); return; }
              const [schAllRes, subAllRes] = await Promise.all([
                getSchedules({ academic_year_id: year.id, semester: sem, day_of_week: effDow }).catch(() => ({ data: { data: [] } })),
                getSubstitutes({ academic_year_id: year.id, date: today }).catch(() => ({ data: { data: [] } })),
              ]);
              setSchoolDaySchedules(schAllRes.data?.data || []);
              setSchoolDaySubstitutes(subAllRes.data?.data || []);
            } catch (e) { console.error('[Dashboard] day schedule error:', e); }
          })());
        }

        // รอ batch 2 ทั้งหมด (โหลดเบื้องหลังหลังแสดงหน้าหลักแล้ว)
        await Promise.all(batch2);
      } catch (e) {
        if (!cancelled) setLoading(false);
      }
    };
    fetch();
    return () => { cancelled = true; };
  }, [user?.id, user?.role]);

  if (loading) return <div className="loading-screen"><div className="spinner"/><span>กำลังโหลด...</span></div>;

  const currentYearSubjects = subjects.filter(s => currentYear && String(s.academic_year_id) === String(currentYear.id));

  // รายวิชาของครูคนนี้: ถ้าเป็น academic/admin เห็นทั้งหมด, teacher/homeroom เห็นเฉพาะที่รับผิดชอบ (API กรองมาให้แล้ว)
  // เรียงตาม ระดับชั้น → ห้อง → ประเภทวิชา
  const typeOrder = { 'พื้นฐาน': 1, 'เพิ่มเติม': 2, 'กิจกรรม': 3 };
  const sortedSubjects = [...currentYearSubjects].sort((a, b) => {
    const ga = Number(a.grade) || 0, gb = Number(b.grade) || 0;
    if (ga !== gb) return ga - gb;
    const ra = Number(a.classroom_room) || 0, rb = Number(b.classroom_room) || 0;
    if (ra !== rb) return ra - rb;
    const ta = typeOrder[a.subject_type] || 9, tb = typeOrder[b.subject_type] || 9;
    if (ta !== tb) return ta - tb;
    return (Number(a.sort_order) || 0) - (Number(b.sort_order) || 0);
  });

  // กรอง
  const mySubjects = sortedSubjects.filter(s => {
    if (filterGrade && String(s.grade) !== filterGrade) return false;
    if (filterRoom && String(s.classroom_room) !== filterRoom) return false;
    return true;
  });

  // สร้าง list ชั้น/ห้อง สำหรับ dropdown
  const gradeOptions = [...new Set(currentYearSubjects.map(s => s.grade).filter(Boolean))].sort((a, b) => Number(a) - Number(b));
  const roomOptions = [...new Set(
    currentYearSubjects
      .filter(s => !filterGrade || String(s.grade) === filterGrade)
      .map(s => s.classroom_room)
      .filter(Boolean)
  )].sort((a, b) => Number(a) - Number(b));

  // ห้องเรียน: academic/admin เห็นทั้งหมด, teacher/homeroom เห็นเฉพาะห้องที่ตัวเองเป็นครูประจำชั้น
  const myClasses = isAcademic()
    ? displayRooms
    : displayRooms.filter(c =>
        String(c.homeroom_teacher_id) === String(user?.id) ||
        String(c.homeroom_teacher2_id) === String(user?.id)
      );

  const isSecondaryLevel = (s) => /ม|มัธยม|junior|middle|senior|high/i.test(s.level_code || s.level_name || '');
  const pctText = (n, total) => (total > 0 ? `${Math.round(n / total * 100)}%` : '—');
  const todayText = new Date().toLocaleDateString('th-TH', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });

  const downloadPp5Cover = async (sub, semester = 0) => {
    try {
      const token = localStorage.getItem('wadphol_token') || '';
      const res = await fetch(
        `${API_BASE}/scores/pp5_cover.php?subject_id=${sub.id}&classroom_id=${sub.classroom_id || 0}${semester === 1 ? '&semester=1' : ''}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!res.ok) throw new Error('PDF error');
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${semester === 1 ? 'ปพ5_ปกความก้าวหน้า_ภาค1' : 'ปพ5_ปก'}_${sub.subject_code || sub.id}_${sub.level_code || ''}${sub.grade || ''}-${sub.room || ''}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch { toast.error('ดาวน์โหลดปก ปพ.5 ไม่สำเร็จ'); }
  };

  return (
    <div className="db">
      <div className="db-head">
        <div>
          <div className="db-date">{todayText}</div>
          <h1 className="db-hello">{user?.prefix}{user?.firstname} {user?.lastname}</h1>
          <div className="db-role">
            {ROLE_LABELS[user?.role] || user?.role}
            {currentYear?.year && <> · ปีการศึกษา {currentYear.year}</>}
          </div>
        </div>
      </div>

      {/* ตัวเลขสรุป (ครู) */}
      {!isAcademic() && (() => {
        // รวมคาบปกติ + คาบร่วม (is_co_teacher) + ซ่อมเสริม (remedial activities)
        const seen = new Set();
        allSchedules.forEach(s => seen.add(`${s.subject_id || 'null'}_${s.classroom_id || 'null'}`));
        const totalSubjectCount = seen.size + remedialActivitiesAll.length;
        const stats = [
          { label: 'รายวิชาที่สอน', value: totalSubjectCount },
          { label: 'ห้องประจำชั้น', value: myClasses.length },
          ...(user?.role === 'teacher' ? [{ label: 'คาบสอนวันนี้', value: todayLessons.length }] : []),
        ];
        return (
          <div className="db-stats">
            {stats.map((s, i) => (
              <div key={i} className="db-stat">
                <div className="db-stat-v">{s.value}</div>
                <div className="db-stat-l">{s.label}</div>
              </div>
            ))}
          </div>
        );
      })()}

      {/* คาบสอนวันนี้ (ครู) */}
      {user?.role === 'teacher' && (
        <div className="db-panel">
          <div className="db-panel-h">
            <h2 className="db-panel-t">คาบสอนวันนี้{todayLessons.length > 0 && <small>{todayLessons.length} คาบ</small>}</h2>
            <button className="db-btn" onClick={() => navigate('/attendance')}>เช็คชื่อรายคาบ</button>
          </div>

          {todayLessons.length === 0 ? (
            <div className="db-empty">วันนี้ไม่มีคาบสอน</div>
          ) : (
            <div>
              {todayLessons.map((lesson, i) => {
                const isHomeroom = Number(lesson.is_homeroom) === 1;
                const isClubPeriod = (pn, sn) => {
                  const check = (s) => s && /ชุมนุม|กิจกรรมชุมนุม|club/i.test(s);
                  return check(pn) || check(sn);
                };
                const handleLessonClick = () => {
                  if (isClubPeriod(lesson.period_name, lesson.subject_name)) {
                    const today = new Date().toISOString().slice(0, 10);
                    const myClubs = allClubs.filter(c => String(c.teacher_user_id) === String(user?.id));
                    const pidParam = lesson.period_id ? `&period_id=${lesson.period_id}` : '';
                    if (myClubs.length === 1) {
                      navigate(`/club-attendance?club_id=${myClubs[0].id}&date=${today}${pidParam}`);
                    } else {
                      navigate(`/club-attendance?date=${today}${pidParam}`);
                    }
                    return;
                  }
                  navigate(`/attendance?classroom_id=${lesson.classroom_id}&period_id=${lesson.period_id}`);
                };
                const openReport = (e) => {
                  e.stopPropagation();
                  if (lesson._isClub) {
                    const now2 = new Date();
                    navigate(`/club-attendance-report?club_id=${lesson._clubId}&month=${now2.getMonth() + 1}&year=${now2.getFullYear()}`);
                  } else {
                    navigate(`/attendance-report?classroom_id=${lesson.classroom_id}&subject_id=${lesson.subject_id || ''}`);
                  }
                };
                const cls = ['db-lesson', lesson._teacherAway ? 'is-away' : isHomeroom ? 'is-homeroom' : ''].join(' ');
                return (
                  <div key={i} className={cls} onClick={handleLessonClick}>
                    <div>
                      <div className="db-lesson-time">{lesson.start_time?.slice(0, 5)}–{lesson.end_time?.slice(0, 5)}</div>
                      <div className="db-lesson-period">{lesson.period_name || `คาบ ${lesson.period_number}`}</div>
                    </div>
                    <div style={{ minWidth: 0 }}>
                      <div className="db-lesson-sub">
                        {lesson.subject_name || 'โฮมรูม'}
                        {lesson._isSubstitute && <span className="db-tag db-tag-warn">สอนแทน {lesson._substituteFor}</span>}
                        {lesson._teacherAway && <span className="db-tag db-tag-warn">ครูไม่อยู่{lesson._awayTeacherName ? ` (${lesson._awayTeacherName})` : ''} · เช็คชื่อแทน</span>}
                        {lesson._coveredBy && <span className="db-tag db-tag-alt">มีคนสอนแทน: {lesson._coveredBy}</span>}
                        {lesson._isCoTeacher && !lesson._isClub && <span className="db-tag">ครูผู้สอนร่วม</span>}
                      </div>
                      <div className="db-lesson-meta">
                        {lesson._isClub
                          ? <>{lesson._clubName ? `${lesson._clubName} · ` : ''}รับชั้น {lesson._clubGradeLabel || 'ทุกชั้น'}</>
                          : <>ชั้น {levelCodePrefix(lesson.level_code)}{lesson.grade}/{lesson.room}</>}
                      </div>
                    </div>
                    <div className="db-actions">
                      <button className="db-link" onClick={(e) => { e.stopPropagation(); handleLessonClick(); }}>เช็คชื่อ</button>
                      <button className="db-link" onClick={openReport}>รายงาน</button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* ══════════ ADMIN / ACADEMIC ══════════ */}
      {isAcademic() && (() => {
        const st = adminStats;
        const loading = adminStatsLoading;
        const att = st?.attendance_today;
        const kpis = [
          {
            label: 'นักเรียนทั้งหมด',
            value: loading ? '…' : (st?.total_students ?? '—'),
            sub: loading ? '' : (st?.students_by_level || []).map(l => `${l.level} ${l.count}`).join(' · '),
          },
          {
            label: 'ครูและบุคลากร',
            value: loading ? '…' : (st?.teacher_count ?? '—'),
            sub: loading ? '' : `บุคลากรทั้งหมด ${st?.staff_count ?? '—'} คน`,
          },
          {
            label: 'มาเรียนวันนี้',
            value: loading ? '…' : (att?.rate != null ? `${att.rate}%` : '—'),
            sub: loading ? '' : (att?.total > 0
              ? `มา ${att.present} · ขาด ${att.absent} · สาย ${att.late} · ลา ${att.leave}`
              : 'ยังไม่มีการเช็คชื่อ'),
          },
          { label: 'รายวิชา', value: mySubjects.length, sub: `${displayRooms.length} ห้องเรียน` },
        ];

        const trend = st?.absence_trend || [];
        const maxAbsent = Math.max(...trend.map(t => t.absent), 1);
        const todayIso = new Date().toISOString().slice(0, 10);
        const p = st?.problem_students || { zero: 0, r: 0, ms: 0, mp: 0 };
        const problems = [
          { label: 'ผลการเรียน 0', count: p.zero },
          { label: 'ผลการเรียน ร', count: p.r },
          { label: 'ผลการเรียน มส', count: p.ms },
          { label: 'ผลการเรียน มผ', count: p.mp },
        ];
        const sp = st?.score_progress || { filled: 0, total: 0, percent: 0 };
        const topClasses = st?.top_absent_classes || [];
        const maxC = topClasses[0]?.count || 1;

        return (
          <>
            <div className="db-stats">
              {kpis.map((k, i) => (
                <div key={i} className="db-stat">
                  <div className="db-stat-v">{k.value}</div>
                  <div className="db-stat-l">{k.label}</div>
                  {k.sub && <div className="db-stat-s">{k.sub}</div>}
                </div>
              ))}
            </div>

            <div className="db-grid2">
              <div className="db-panel">
                <div className="db-panel-h"><h3 className="db-panel-t">จำนวนขาดเรียน 7 วันล่าสุด</h3></div>
                <div className="db-panel-b">
                  {loading ? <div className="db-empty">กำลังโหลด…</div>
                    : trend.length === 0 ? <div className="db-empty">ยังไม่มีข้อมูล</div>
                    : (
                      <div className="db-bars">
                        {trend.map((t, i) => (
                          <div key={i} className={`db-bar${t.date === todayIso ? ' is-today' : ''}`}>
                            <div className="db-bar-v">{t.absent || ''}</div>
                            <div className="db-bar-fill" style={{ height: Math.round((t.absent / maxAbsent) * 80) }} />
                            <div className="db-bar-l">{t.label}</div>
                          </div>
                        ))}
                      </div>
                    )}
                </div>
              </div>

              <div className="db-panel">
                <div className="db-panel-h"><h3 className="db-panel-t">นักเรียนที่ผลการเรียนมีปัญหา</h3></div>
                <div className="db-panel-b">
                  {problems.every(x => !x.count) ? <div className="db-empty">ไม่พบ</div> : (
                    <div className="db-rows">
                      {problems.map((x, i) => (
                        <div key={i}>
                          <span>{x.label}</span>
                          <span className={`db-num${x.count ? ' db-num-bad' : ''}`}>{x.count || '–'} {x.count ? 'คน' : ''}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="db-grid2">
              <div className="db-panel">
                <div className="db-panel-h">
                  <h3 className="db-panel-t">การกรอกคะแนน</h3>
                  <span className="db-num">{sp.filled}/{sp.total} วิชา · {sp.percent}%</span>
                </div>
                <div className="db-panel-b">
                  <div className="db-meter" style={{ marginBottom: 16 }}><span style={{ width: `${sp.percent}%` }} /></div>
                  <div className="db-muted" style={{ fontSize: 13, marginBottom: 6 }}>ครูที่ยังกรอกไม่ครบ</div>
                  {(st?.teachers_no_score || []).length === 0 ? (
                    <div style={{ fontSize: 14 }}>กรอกครบทุกคนแล้ว</div>
                  ) : (
                    <div className="db-rows">
                      {(st?.teachers_no_score || []).slice(0, 5).map((t, i) => (
                        <div key={i}>
                          <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.name}</span>
                          <span className="db-muted" style={{ fontSize: 13, whiteSpace: 'nowrap' }}>{t.percent}% · ค้าง {t.missing}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="db-panel">
                <div className="db-panel-h"><h3 className="db-panel-t">ห้องที่ขาดเรียนมากที่สุด <small>สัปดาห์นี้</small></h3></div>
                <div className="db-panel-b">
                  {topClasses.length === 0 ? <div className="db-empty">ไม่มีข้อมูลสัปดาห์นี้</div> : (
                    <div className="db-rows">
                      {topClasses.map((c, i) => (
                        <div key={i} style={{ display: 'grid', gridTemplateColumns: '22px 70px 1fr 64px' }}>
                          <span className="db-muted">{i + 1}</span>
                          <span style={{ fontWeight: 600 }}>{c.class}</span>
                          <div className="db-meter"><span style={{ width: `${Math.round(c.count / maxC * 100)}%`, background: '#dc2626' }} /></div>
                          <span className="db-num" style={{ textAlign: 'right' }}>{c.count} ครั้ง</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {(st?.top_absent_students || []).length > 0 && (
              <div className="db-panel">
                <div className="db-panel-h"><h3 className="db-panel-t">นักเรียนที่ขาดเรียนบ่อย <small>10 อันดับแรกของปีการศึกษา</small></h3></div>
                <div style={{ overflowX: 'auto' }}>
                  <table className="db-table">
                    <thead>
                      <tr><th style={{ width: 40 }}>#</th><th>ชื่อ-นามสกุล</th><th>ห้อง</th><th className="r">ขาด (วัน)</th></tr>
                    </thead>
                    <tbody>
                      {(st?.top_absent_students || []).map((s, i) => (
                        <tr key={i}>
                          <td className="db-muted">{i + 1}</td>
                          <td>{s.name}</td>
                          <td className="db-muted">{s.class}</td>
                          <td className="r db-num db-num-bad">{s.absent_days}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <div className="db-panel">
              <div className="db-panel-h"><h3 className="db-panel-t">ไปที่</h3></div>
              <div className="db-quick">
                {[
                  { label: 'รายวิชา', path: '/subjects' },
                  { label: 'กรอกคะแนน', path: '/score-classrooms' },
                  { label: 'ตารางสอน / เช็คชื่อ', path: '/attendance' },
                  { label: 'นักเรียน', path: '/students' },
                  { label: 'ครูและบุคลากร', path: '/teachers' },
                  { label: 'ชุมนุม', path: '/clubs' },
                  { label: 'รายงานผลการประเมิน', path: '/evaluation-report' },
                  { label: 'ตั้งค่า', path: '/settings' },
                ].map((m, i) => (
                  <button key={i} onClick={() => navigate(m.path)}>{m.label}</button>
                ))}
              </div>
            </div>
          </>
        );
      })()}

      {/* รายวิชาที่รับผิดชอบ */}
      {!isAcademic() && mySubjects.length > 0 && user?.role !== 'homeroom' && (
        <div className="db-panel">
          <div className="db-panel-h">
            <h2 className="db-panel-t">รายวิชาที่รับผิดชอบ<small>{mySubjects.length} วิชา</small></h2>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
              <select className="db-select" value={filterGrade} onChange={e => { setFilterGrade(e.target.value); setFilterRoom(''); }}>
                <option value="">ทุกชั้น</option>
                {gradeOptions.map(g => <option key={g} value={g}>ป.{g}</option>)}
              </select>
              <select className="db-select" value={filterRoom} onChange={e => setFilterRoom(e.target.value)}>
                <option value="">ทุกห้อง</option>
                {roomOptions.map(r => <option key={r} value={r}>ห้อง {r}</option>)}
              </select>
              {(filterGrade || filterRoom) && (
                <button className="db-link" onClick={() => { setFilterGrade(''); setFilterRoom(''); }}>ล้างตัวกรอง</button>
              )}
            </div>
          </div>
          <div className="db-panel-b">
            <div className="db-cards">
              {mySubjects.map(sub => {
                const total = Number(sub.student_count) || 0;
                const hasSem1 = Number(sub.indicator_sem1) > 0;
                const hasSem2 = Number(sub.indicator_sem2) > 0;
                const subProg = qualProgress[sub.id] || {};
                const hasQual = qTypes.length > 0 && total > 0;
                const showProgress = sub.subject_type !== 'กิจกรรม' && (hasSem1 || hasSem2 || hasQual);
                return (
                  <div key={sub.id} className="db-card">
                    <div className="db-card-top">
                      <span className="db-code">{sub.subject_code}</span>
                      <span className="db-type">{sub.subject_type}</span>
                    </div>
                    <div className="db-card-name">{sub.subject_name}</div>
                    <div className="db-card-meta">
                      {isSecondaryLevel(sub) ? 'ม.' : 'ป.'}{sub.grade}{sub.classroom_room ? `/${sub.classroom_room}` : ''}
                      {' · '}{sub.credits} หน่วยกิต
                      {sub.teacher_names && <> · {sub.teacher_names}</>}
                    </div>
                    {showProgress && (
                      <div className="db-progress">
                        {(hasSem1 || hasSem2) && (
                          <span>คะแนน
                            {hasSem1 && <> ภ.1 <b>{pctText(Number(sub.scored_sem1) || 0, total)}</b></>}
                            {hasSem2 && <> ภ.2 <b>{pctText(Number(sub.scored_sem2) || 0, total)}</b></>}
                          </span>
                        )}
                        {hasQual && qTypes.map(t => {
                          const tp = subProg[t.type_key] || {};
                          return (
                            <span key={t.type_key} title={t.label}>
                              {(t.label || '').length > 14 ? `${t.label.slice(0, 14)}…` : t.label}{' '}
                              <b>{pctText(tp[1] || 0, total)}</b>/<b>{pctText(tp[2] || 0, total)}</b>
                            </span>
                          );
                        })}
                      </div>
                    )}
                    {!isSecondaryLevel(sub) && (
                      <div className="db-card-actions">
                        <button className="db-btn db-btn-primary" onClick={() => navigate(`/scores/${sub.id}/${sub.classroom_id || 0}`)}>กรอกคะแนน</button>
                        <button className="db-btn" onClick={() => navigate(`/subject-result/${sub.id}/${sub.classroom_id || 0}`)}>ผลการเรียน</button>
                        {(sub.subject_name || '').includes('ชุมนุม')
                          ? <button className="db-btn" onClick={() => navigate('/clubs')}>จัดการชุมนุม</button>
                          : <button className="db-btn" onClick={() => navigate(`/indicators/${sub.id}/${sub.classroom_id || 0}`)}>ตัวชี้วัด</button>}
                        {/^ป/.test(sub.level_code || '') && sub.subject_type !== 'กิจกรรม' && (
                          <button className="db-btn" onClick={() => downloadPp5Cover(sub, 1)}>ปกความก้าวหน้า ภาค 1</button>
                        )}
                        {isSem2 && <button className="db-btn" onClick={() => downloadPp5Cover(sub)}>ปก ปพ.5</button>}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* ห้องประจำชั้น */}
      {!isAcademic() && myClasses.length > 0 && (
        <div className="db-panel">
          <div className="db-panel-h"><h2 className="db-panel-t">ห้องประจำชั้น</h2></div>
          <div className="db-panel-b">
            <div className="db-cards db-cards-sm">
              {myClasses.map(cls => (
                <div key={cls.key || cls.id}
                  className={`db-card${cls.id ? ' is-link' : ''}`}
                  style={{ opacity: cls.id ? 1 : 0.55 }}
                  onClick={() => cls.id && navigate(`/students/${cls.id}`)}>
                  <div className="db-card-name" style={{ marginTop: 0 }}>{cls.label}</div>
                  <div className="db-card-meta">{cls.level_name || ''}</div>
                  {cls.homeroom1_name && <div className="db-card-meta" style={{ marginTop: 4 }}>ครู {cls.homeroom1_name}</div>}
                  <div style={{ marginTop: 10 }}>
                    {cls.id ? <span className="db-link">ดูรายชื่อนักเรียน</span> : <span className="db-muted" style={{ fontSize: 13 }}>ยังไม่มีข้อมูล</span>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ══════════ ADMIN / ACADEMIC — ตารางสอนทั้งโรงเรียนวันนี้ ══════════ */}
      {isAcademic() && (() => {
        const DOW_NAMES = ['อาทิตย์','จันทร์','อังคาร','พุธ','พฤหัสบดี','ศุกร์','เสาร์'];
        const dayLabel = DOW_NAMES[schoolDayInfo.dow] || '-';
        const subIndex = new Map();
        (schoolDaySubstitutes || []).forEach(s => {
          subIndex.set(`${s.classroom_id}|${s.period_id}`, s);
        });
        // รวม rows ที่มี classroom_id + period_id เดียวกัน (เช่น ลูกเสือ+เนตรนารีที่บันทึกแยก row) → รวมชื่อครู
        const mergeMap = new Map();
        (schoolDaySchedules || []).filter(s => s.teacher_id || s.classroom_id).forEach(s => {
          const k = `${s.classroom_id}|${s.period_id}`;
          if (!mergeMap.has(k)) {
            mergeMap.set(k, { ...s, _teacherNames: s.teacher_name ? [s.teacher_name] : [] });
          } else {
            const existing = mergeMap.get(k);
            if (s.teacher_name && !existing._teacherNames.includes(s.teacher_name)) {
              existing._teacherNames.push(s.teacher_name);
              existing.teacher_name = existing._teacherNames.join(' / ');
            }
          }
        });
        let rows = [...mergeMap.values()];
        if (schoolDayFilterTeacher) {
          const rawFiltered = (schoolDaySchedules || []).filter(s => String(s.teacher_id) === String(schoolDayFilterTeacher));
          const keys = new Set(rawFiltered.map(s => `${s.classroom_id}|${s.period_id}`));
          rows = rows.filter(r => keys.has(`${r.classroom_id}|${r.period_id}`));
        }
        (schoolDaySubstitutes || []).forEach(s => {
          const exists = rows.some(r => String(r.classroom_id) === String(s.classroom_id) && String(r.period_id) === String(s.period_id));
          // เมื่อ filter ครู → เพิ่มเฉพาะคาบที่ครูที่เลือกไปสอนแทนคนอื่น (ไม่ใช่คาบที่ตัวเองถูกแทน เพราะนั้นอยู่ใน rows แล้ว)
          if (schoolDayFilterTeacher) {
            const isSubTeacher = String(s.substitute_teacher_id) === String(schoolDayFilterTeacher);
            if (!exists && isSubTeacher) {
              rows.push({
                _fromSubstitute: true,
                classroom_id: s.classroom_id, period_id: s.period_id,
                period_number: s.period_number, period_name: s.period_name,
                start_time: s.start_time, end_time: s.end_time,
                subject_id: s.effective_subject_id || s.subject_id,
                subject_name: s.subject_name, subject_code: s.subject_code,
                teacher_id: s.substitute_teacher_id, teacher_name: s.substitute_teacher_name,
                level_code: s.level_code, level_name: s.level_name,
                grade: s.grade, room: s.room,
              });
            }
          } else if (!exists) {
            rows.push({
              _fromSubstitute: true,
              classroom_id: s.classroom_id, period_id: s.period_id,
              period_number: s.period_number, period_name: s.period_name,
              start_time: s.start_time, end_time: s.end_time,
              subject_id: s.effective_subject_id || s.subject_id,
              subject_name: s.subject_name, subject_code: s.subject_code,
              teacher_id: null, teacher_name: '(จัดสอนแทน)',
              level_code: s.level_code, level_name: s.level_name,
              grade: s.grade, room: s.room,
            });
          }
        });
        const byPeriod = new Map();
        rows.forEach(r => {
          const k = String(r.period_id);
          if (!byPeriod.has(k)) byPeriod.set(k, []);
          byPeriod.get(k).push(r);
        });
        const sortedPeriods = [...byPeriod.entries()].sort((a, b) =>
          Number(a[1][0]?.period_number ?? 999) - Number(b[1][0]?.period_number ?? 999)
        );
        const teacherOptions = [...new Map(
          (schoolDaySchedules || []).filter(s => s.teacher_id).map(s => [String(s.teacher_id), { id: s.teacher_id, name: s.teacher_name }])
        ).values()].sort((a, b) => (a.name || '').localeCompare(b.name || '', 'th'));

        return (
          <div className="db-panel">
            <div className="db-panel-h">
              <h2 className="db-panel-t">
                ตารางสอนวันนี้ทั้งโรงเรียน
                <small>
                  วัน{dayLabel} {new Date(schoolDayInfo.date || Date.now()).toLocaleDateString('th-TH', { day: 'numeric', month: 'short', year: 'numeric' })}
                  {(schoolDaySubstitutes || []).length > 0 && ` · สอนแทน ${schoolDaySubstitutes.length} คาบ`}
                </small>
              </h2>
              <select className="db-select" value={schoolDayFilterTeacher} onChange={e => setSchoolDayFilterTeacher(e.target.value)}>
                <option value="">ครูทั้งหมด</option>
                {teacherOptions.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
              </select>
            </div>
            {schoolDayInfo.isHoliday ? (
              <div className="db-empty">วันหยุด{schoolDayInfo.holidayName ? ` — ${schoolDayInfo.holidayName}` : ''}</div>
            ) : sortedPeriods.length === 0 ? (
              <div className="db-empty">ไม่มีตารางสอนวันนี้</div>
            ) : (
              <div style={{ overflowX: 'auto', padding: '0 16px 16px' }}>
                <table className="db-table db-table-grid" style={{ marginTop: 14 }}>
                  <thead>
                    <tr>
                      <th className="c" style={{ width: 70 }}>คาบ</th>
                      <th className="c" style={{ width: 110 }}>เวลา</th>
                      <th className="c" style={{ width: 80 }}>ห้อง</th>
                      <th>วิชา</th>
                      <th>ครูผู้สอน</th>
                      <th style={{ width: 200 }}>หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedPeriods.map(([pid, items]) => {
                      const sorted = [...items].sort((a, b) =>
                        (a.level_code || '').localeCompare(b.level_code || '', 'th')
                        || Number(a.grade || 0) - Number(b.grade || 0)
                        || Number(a.room || 0) - Number(b.room || 0)
                      );
                      return sorted.map((r, idx) => {
                        const sub = subIndex.get(`${r.classroom_id}|${r.period_id}`);
                        const isCovered = !!sub;
                        const teacherDisplay = isCovered ? sub.substitute_teacher_name : (r.teacher_name || '-');
                        const subjectDisplay = isCovered ? (sub.subject_name || r.subject_name || '-') : (r.subject_name || r.note || '-');
                        return (
                          <tr key={`${pid}_${r.classroom_id}_${r.teacher_id || 'x'}_${idx}`} style={{ background: isCovered ? '#fffbeb' : undefined }}>
                            {idx === 0 && <td rowSpan={sorted.length} className="c" style={{ fontWeight: 600, verticalAlign: 'middle' }}>{r.period_name || `คาบ ${r.period_number}`}</td>}
                            {idx === 0 && <td rowSpan={sorted.length} className="c db-muted" style={{ fontSize: 13, verticalAlign: 'middle' }}>{r.start_time?.slice(0,5)}–{r.end_time?.slice(0,5)}</td>}
                            <td className="c" style={{ fontWeight: 600 }}>{levelCodePrefix(r.level_code)}{r.grade}/{r.room}</td>
                            <td>
                              {r.subject_code && <span className="db-muted" style={{ marginRight: 6 }}>{r.subject_code}</span>}
                              {subjectDisplay}
                            </td>
                            <td>
                              {isCovered ? (
                                <>
                                  <span style={{ color: '#b45309', fontWeight: 600 }}>{teacherDisplay}</span>
                                  {sub.original_teacher_name && <div className="db-muted" style={{ fontSize: 12, textDecoration: 'line-through' }}>{sub.original_teacher_name}</div>}
                                </>
                              ) : teacherDisplay}
                            </td>
                            <td style={{ fontSize: 13 }} className="db-muted">
                              {isCovered && <span className="db-tag db-tag-warn" style={{ marginLeft: 0 }}>สอนแทน{sub.original_teacher_name ? ` ${sub.original_teacher_name}` : ''}</span>}
                              {sub?.note && <div style={{ marginTop: 2 }}>{sub.note}</div>}
                              {r.note && !isCovered && <span>{r.note}</span>}
                            </td>
                          </tr>
                        );
                      });
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      })()}
    </div>
  );
}
